// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useOnlineStatus } from '@hooks/useOnlineStatus';

export default function OfflineBanner() {
  const { isOnline, wasOffline } = useOnlineStatus();
  const [showReconnect, setShowReconnect] = useState(false);

  useEffect(() => {
    if (isOnline && wasOffline) {
      setShowReconnect(true);
      const timer = setTimeout(() => setShowReconnect(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  return (
    <AnimatePresence>
      {!isOnline ? (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="glass-pill border-b border-yellow-400/20 bg-yellow-500/10"
        >
          <div className="flex items-center justify-center gap-2 px-4 py-2 text-sm text-yellow-600 dark:text-yellow-400">
            <WifiOff className="h-4 w-4" />
            <span>You are offline. Some features may be unavailable.</span>
          </div>
        </motion.div>
      ) : showReconnect ? (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="glass-pill border-b border-emerald-400/20 bg-emerald-500/10"
        >
          <div className="flex items-center justify-center gap-2 px-4 py-2 text-sm text-green-600 dark:text-green-400">
            <Wifi className="h-4 w-4" />
            <span>Back online!</span>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
